"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostView = void 0;
var react_1 = __importStar(require("react"));
var PostMedia_1 = require("./PostMedia");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var postSlice_1 = require("../../features/post/postSlice");
var PostVIewSkeleton_1 = require("./PostVIewSkeleton");
var fingerprint_1 = __importDefault(require("../../helpers/fingerprint"));
var schemaSlice_1 = require("../../features/post/schemaSlice");
var globalSlice_1 = require("../../features/global/globalSlice");
var ModalContent_1 = __importDefault(require("./ModalContent/ModalContent"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PostView = function (_a) {
    var _b = _a.isPreview, isPreview = _b === void 0 ? false : _b, slug = _a.slug, postId = _a.postId;
    var dispatch = react_redux_1.useDispatch();
    var postData = react_redux_1.useSelector(postSlice_1.selectSinglePost);
    var isPostLoading = react_redux_1.useSelector(postSlice_1.selectPostLoading);
    var _c = react_1.useState(''), fingerprint = _c[0], setFingerprint = _c[1];
    var _d = react_1.useState([]), postMedia = _d[0], setMediaData = _d[1];
    var _e = react_1.useState(false), isRelatedPostClicked = _e[0], setIsRelatedPostClicked = _e[1];
    react_2.useEffect(function () {
        fingerprint_1.default().then(function (response) { return setFingerprint(response); });
    }, []);
    // Re-run init whenever the target slug/postId changes (e.g. navigating
    // to a different post while the modal is still mounted) or when a related
    // post is clicked inside the modal.
    react_2.useEffect(function () {
        init();
    }, [slug, postId, isRelatedPostClicked]);
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Clear any stale 404 state from a previous failed navigation before
                    // starting the new fetch so the NotFound page does not flash incorrectly.
                    dispatch(globalSlice_1.setIsPageNotFound(false));
                    dispatch(schemaSlice_1.getPreviewSchema());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!postId) return [3 /*break*/, 2];
                    dispatch(postSlice_1.getMyAnnouncementPost(postId));
                    return [3 /*break*/, 4];
                case 2:
                    if (!slug) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(postSlice_1.getPostBySlug(slug))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    dispatch(globalSlice_1.setIsPageNotFound(true));
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (isPostLoading || !postData) {
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_post_view },
            react_1.default.createElement(PostVIewSkeleton_1.PostViewSkeleton, null)));
    }
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_post_view },
        react_1.default.createElement(PostMedia_1.PostMedia, { skeleton: isPostLoading, media: postMedia }),
        react_1.default.createElement(ModalContent_1.default, { fingerprint: fingerprint, isPreview: isPreview, isPostLoading: isPostLoading, setMediaData: setMediaData, setIsRelatedPostClicked: setIsRelatedPostClicked, isRelatedPostClicked: isRelatedPostClicked })));
};
exports.PostView = PostView;
